// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".export-btn[data-v-02fd6b58] {\n  display: inline-block;\n}\n.export-btn .el-dialog__header[data-v-02fd6b58] {\n  padding: 0;\n}\n.export-btn .el-dialog__body[data-v-02fd6b58] {\n  padding: 15px 20px;\n}\n.export-btn .el-dialog[data-v-02fd6b58] {\n  width: 250px;\n  min-width: 250px !important;\n}\n", ""]);
// Exports
module.exports = exports;
